export const LOAD_ALLOWED_ASSESSMENT_AND_WELL_BEING_FEATURES_SUCCESS = "LOAD_ALLOWED_ASSESSMENT_AND_WELL_BEING_FEATURES_SUCCESS";

export const LOAD_ALLOWED_ASSESSMENT_AND_WELL_BEING_FEATURES = "LOAD_ALLOWED_ASSESSMENT_AND_WELL_BEING_FEATURES";
